import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faX, faUpload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../Messages/Messages';
import { useNavigate, useLocation} from 'react-router-dom';
import { decryptData } from '../../utils/storageCrypto';
import { FiChevronDown, FiSearch } from "react-icons/fi";



function NewOrganization() {

  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const initialData = {
    organization_name: '',
    company_name: '',
    zoneId: '',
    email: '',
    mobile_number: '',
    gst: '',
    pan: '',
    address1: '',
    city: '',
    pincode: '',
    state: '',
    website_url: '',
  };
  const [isDirty, setIsDirty] = useState(false);
  const [data, setData] = useState(initialData);
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [filteredPincodes, setFilteredPincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [pincodeSearch, setPincodeSearch] = useState('');
  const [showPincodeDropdown, setShowPincodeDropdown] = useState(false);
  const [isPincodeLoading, setIsPincodeLoading] = useState(false);
  const [manualPincodeLoading, setManualPincodeLoading] = useState(false);
  const [pincodeApiError, setPincodeApiError] = useState('');
  const [manualPincode, setManualPincode] = useState('');
  const [manualArea, setManualArea] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  //const { setHasUnsavedChanges } = useOutletContext();
  const [imagePreview, setImagePreview] = useState(null);
  const [image,setImage] = useState('');
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const [zones, setZones] = useState([]);

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const states = [
    { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
    { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
    { value: 'Assam', label: 'Assam' },
    { value: 'Bihar', label: 'Bihar' },
    { value: 'Chhattisgarh', label: 'Chhattisgarh' },
    { value: 'Goa', label: 'Goa' },
    { value: 'Gujarat', label: 'Gujarat' },
    { value: 'Haryana', label: 'Haryana' },
    { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
    { value: 'Jammu and Kashmir', label: 'Jammu and Kashmir' },
    { value: 'Jharkhand', label: 'Jharkhand' },
    { value: 'Karnataka', label: 'Karnataka' },
    { value: 'Kerala', label: 'Kerala' },
    { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
    { value: 'Maharashtra', label: 'Maharashtra' },
    { value: 'Manipur', label: 'Manipur' },
    { value: 'Meghalaya', label: 'Meghalaya' },
    { value: 'Mizoram', label: 'Mizoram' },
    { value: 'Nagaland', label: 'Nagaland' },
    { value: 'Odisha', label: 'Odisha' },
    { value: 'Punjab', label: 'Punjab' },
    { value: 'Rajasthan', label: 'Rajasthan' },
    { value: 'Sikkim', label: 'Sikkim' },
    { value: 'Tamil Nadu', label: 'Tamil Nadu' },
    { value: 'Telangana', label: 'Telangana' },
    { value: 'Tripura', label: 'Tripura' },
    { value: 'Uttarakhand', label: 'Uttarakhand' },
    { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
    { value: 'West Bengal', label: 'West Bengal' },
  ]; 

  useEffect(() => {
    fetchZones();
  },[]);  


  const fetchZones = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);
      const response = await fetch(`${fetchUrl}zone/get-all-zones`, {
        method: 'GET',
        headers: {
          'x-token': token,
        },
      });
      const responseData = await response.json();
      console.log("Zones fetched: ", responseData);
      if (response.ok) {
        setZones(responseData.data || []);
      } else {
        console.error('Failed to fetch zones');
      }
    } catch (error) {
      console.error('Error fetching zones:', error);
    }
  };


  useEffect(() => {
    const fetchPincodesByCity = async () => {
      const cityQuery = data.city.trim();
      if (!cityQuery) {
        setFilteredPincodes([]);
        setPincodeApiError('');
        setIsPincodeLoading(false);
        return;
      }

      setIsPincodeLoading(true);
      setPincodeApiError('');

      try {
        const response = await fetch(
          `https://api.postalpincode.in/postoffice/${encodeURIComponent(cityQuery)}`
        );
        const json = await response.json();

        if (!Array.isArray(json) || json.length === 0 || json[0]?.Status !== 'Success') {
          setFilteredPincodes([]);
          setPincodeApiError('Unable to fetch pincodes for this city. You can enter them manually.');
          return;
        }

        const postOffices = json[0].PostOffice || [];
        const matches = postOffices
          .map((office) => ({
            id: `${office.Pincode}-${office.Name}`,
            pincode: office.Pincode,
            area: office.Name || office.Block || office.District || 'Unknown',
          }))
          .filter(
            (item, index, arr) =>
              arr.findIndex(
                (existing) =>
                  existing.pincode === item.pincode && existing.area === item.area
              ) === index
          )
          .sort((a, b) => a.pincode.localeCompare(b.pincode));

        setFilteredPincodes(matches);
      } catch (error) {
        console.error('Failed to fetch pincodes from public API', error);
        setFilteredPincodes([]);
        setPincodeApiError('Failed to fetch pincodes. Please add them manually if needed.');
      } finally {
        setIsPincodeLoading(false);
      }
    };

    const delayId = setTimeout(() => {
      setSelectedPincodes([]);
      setPincodeSearch('');
      fetchPincodesByCity();
    }, 500);

    return () => clearTimeout(delayId);
  }, [data.city]);

  const fetchAreaForPincode = async (pincode) => {
    if (!/^[0-9]{6}$/.test(pincode)) {
      return;
    }

    setManualPincodeLoading(true);
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${encodeURIComponent(pincode)}`
      );
      const json = await response.json();

      if (Array.isArray(json) && json.length > 0 && json[0]?.Status === 'Success') {
        const office = json[0].PostOffice?.[0];
        if (office) {
          const areaFromApi = office.Name || office.Block || office.District || office.Division || office.Region || office.State;
          if (areaFromApi) {
            setManualArea(areaFromApi);
            setPincodeApiError('');
            return;
          }
        }
      }

      setPincodeApiError('Could not resolve area name from pincode. Enter it manually if available.');
    } catch (fetchError) {
      console.error('Failed to fetch area name for pincode', fetchError);
      setPincodeApiError('Failed to resolve area from pincode. You can still add it manually.');
    } finally {
      setManualPincodeLoading(false);
    }
  };

  useEffect(() => {
    if (manualPincode.length === 6 && /^[0-9]{6}$/.test(manualPincode) && !manualArea) {
      fetchAreaForPincode(manualPincode);
    }
  }, [manualPincode]);

  const addManualPincode = () => {
    const cleaned = manualPincode.trim();
    if (!cleaned) {
      setPincodeApiError('Please enter a valid pincode.');
      return;
    }
    if (!/^[0-9]{6}$/.test(cleaned)) {
      setPincodeApiError('Pincode must be a 6-digit number.');
      return;
    }

    const newItem = {
      id: `${cleaned}-${manualArea.trim() || 'Manual'}`,
      pincode: cleaned,
      area: manualArea.trim() || 'Manual Entry',
    };

    if (
      selectedPincodes.some(
        (selected) => selected.pincode === newItem.pincode && selected.area === newItem.area
      )
    ) {
      setPincodeApiError('This pincode is already selected.');
      return;
    }

    setSelectedPincodes((prev) => [...prev, newItem]);
    setManualPincode('');
    setManualArea('');
    setPincodeApiError('');
  };

  const handleStayHere = () => {
    setShowCancelPopup(false);
  };

  const handleLeave = () => {
    setShowCancelPopup(false);
    navigate(-1);
  };

  const filteredStates = states.filter((state) =>
  state.label.toLowerCase().includes(stateSearch.toLowerCase())
);

 const handleChange = (e) => {
  const { name, value } = e.target;
  let error = "";

  if (name === 'city') {
    setSelectedPincodes([]);
    setPincodeSearch('');
    setPincodeApiError('');
  }

  setErrorMessages((prev) =>
  prev.filter((msg) => !msg.toLowerCase().includes(name.replace("_", " ")))
);

  if (name === "organization_name") {
    if (!value.trim()) {
      error = "Organization Name is required";
    }
  }

  if (name === "company_name") {
    if (!value.trim()) {
      error = "Company Name is required";
    }
  }

  if (name === "mobile_number") {
    if (!/^[0-9]*$/.test(value)) {
      error = "Only numbers allowed";
    } else if (value.length > 10) {
      error = "Mobile number should not exceed 10 digits";
    } else if (value.length > 0 && value.length < 10) {
      error = "Enter 10 digit mobile number";
    }
  }

  if (name === "email") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      error = "Enter valid email address";
    }
  }

  if (name === "gst") {
    const upperGST = value.toUpperCase();

    if (upperGST.length > 15) return;

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;

    if (upperGST.length === 15 && !gstRegex.test(upperGST)) {
      error = "Invalid GST format";
    }

    if (upperGST.length >= 12) {
      const extractedPan = upperGST.substring(2, 12);

      setData((prev) => ({
        ...prev,
        gst: upperGST,
        pan: extractedPan
      }));
    } else {
      setData((prev) => ({
        ...prev,
        gst: upperGST
      }));
    }

    setErrors((prev) => ({
      ...prev,
      gst: error
    }));

    return;
  }

  setData((prev) => ({
    ...prev,
    [name]: value
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: error
  }));
};

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleLogoRemove = () => {
    setLogo(null);
    setLogoPreview(null);
  };

  const handleCloseError = () => {
    setErrorMessages([]);
  };


  const handleSubmit = async (attempt = 1) => {
    const errorMessages = [];

    if (!data.organization_name) {
      errorMessages.push('Enter the Organization Name.');
    }
    if (!data.company_name) {
      errorMessages.push('Enter the Company Name.');
    }

    if (!data.zoneId) {
      errorMessages.push('Select Zone.');
    }

   if (!data.mobile_number) {
  errorMessages.push('Enter Mobile Number.');
} else if (data.mobile_number.length !== 10 || !/^[0-9]+$/.test(data.mobile_number)) {
  errorMessages.push('Enter 10 digit Mobile Number.');
}

if (!data.email) {
  errorMessages.push('Enter Email.');
} else {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(data.email)) {
    errorMessages.push('Please enter a valid email address.');
  }
}

if (!data.gst) {
  errorMessages.push('Enter GST.');
} else {
  const gstRegex = /^[0-9A-Z]{15}$/;
  if (!gstRegex.test(data.gst)) {
    errorMessages.push('Invalid GST format.');
  }
}

if (selectedPincodes.length === 0) {
  errorMessages.push('Select at least one serviceable pincode.');
}

    if (errorMessages.length > 0) {
      setErrors(prevState => ({
        ...prevState,
        organization_name: errorMessages.find(msg => msg.includes('Organization Name')) || '',
        company_name: errorMessages.find(msg => msg.includes('Company Name')) || '',
        zoneId: errorMessages.find(msg => msg.includes('Zone')) || '',
        mobile_number: errorMessages.find(msg => msg.includes('Mobile Number')) || '',
        email: errorMessages.find(msg => msg.includes('email address')) || '',
        gst: errorMessages.find(msg => msg.includes('GST format')) || '',
        pan: errorMessages.find(msg => msg.includes('PAN format')) || '',
        servicable_pincodes: errorMessages.find(msg => msg.includes('serviceable pincode')) || ''
      }));
      setErrorMessages(errorMessages);
      return;
    }

    setIsSaving(true);
    setIsLoading(true);

    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const formData = new FormData();
      console.log(formData);
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      selectedPincodes.forEach((item) => {
        formData.append('servicable_pincodes', item.pincode);
      });
      formData.append('logo', image);
    
      const response = await fetch(`${fetchUrl}organization/create-organization`, {
        method: 'POST',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      console.log("formData: ", formData);
    
      const responseData = await response.json();
      console.log("Response Data: ", responseData);
      if (response.ok) {
        // resetForm();
        setPopupType('200or201');
        setPopupMessage('Organization created successfully');
        setShowPopup(true);
    
        setTimeout(() => {
          navigate('/bb/app/settings/organizationlist');
        }, 3000);
      } else {
        if (response.status === 400) {
          setPopupType('400');
          setPopupMessage(responseData.message);
          setShowPopup(true);
        } else {
          setPopupType('500');
          setPopupMessage('Internal Server Error');
          setShowPopup(true);
        }
      }
    } catch (error) {
      console.log("Error creating organization: ", error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => handleSubmit(attempt + 1), 1000);
      } else {
        setErrorMessages(['Internal Server Error. Kindly Retry.']);
      }
    } finally {
      setIsLoading(false);
      setIsSaving(false);
    }
  };

  const closePopup = () => {
    console.log("closePopup called");
    setShowPopup(false);
  };

  const Retry = () => {
    handleSubmit();
  };

  const handleCancel = () => {
    if (isDirty) {
      setShowCancelPopup(true);
    } else {
      navigate(-1);
    }
  };
  
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      setImage(file)
    }
  };

  return (
<div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">      
  <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">New Organization</h1>
                </div>
              </div>
              {errorMessages.length > 0 && (
                <div className="flex justify-between items-center px-auto py-3 bg-[#fddcde] rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                        • {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className="px-4">
                    <button
                      className="text-gray-700 hover:text-red-500"
                      onClick={handleCloseError}
                    >
                      <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                    </button>
                  </div>
                </div>
              )}

             

<div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">         
                
<div className="w-full flex flex-col justify-start items-start px-4 bg-[#F9F9FB]">
<div className='w-full flex flex-row'>
<div className="flex flex-col w-full">
 <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
  <label htmlFor="organizationname" className="block text-sm font-regular whitespace-nowrap text-[#e54643] w-1/6">
    Organization Name <span> *</span>

  </label>
  <input
    type="text"
    id="organization_name"
    name="organization_name"
    value={data.organization_name}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.organization_name && <p className="text-red-500 text-sm">{errors.organization_name}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
  <label htmlFor="companyname" className="block text-sm font-regular text-red-500 w-1/6">
    Company Name<span> *</span>
  </label>
  <input
    type="text"
    id="company_name"
    name="company_name"
    value={data.company_name}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.company_name && <p className="text-red-500 text-sm">{errors.company_name}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
  <label
    htmlFor="zoneId"
    className="block text-sm font-regular text-red-500 w-1/6"
  >
    Zone <span>*</span>
  </label>

  <select
    id="zoneId"
    name="zoneId"
    value={data.zoneId}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  >
    <option value="">Select Zone</option>

    {zones.map((zone) => (
      <option key={zone._id} value={zone._id}>
        {zone.zone_name}
      </option>
    ))}
  </select>

  {errors.zoneId && (
    <p className="text-red-500 text-sm">{errors.zoneId}</p>
  )}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
  <label htmlFor="email" className="block text-sm font-regular text-red-500 w-1/6">
    Email<span> *</span>
  </label>
  <input
    type="text"
    id="email"
    name="email"
    value={data.email}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
  <label htmlFor="mobile_number" className="block text-sm font-regular text-red-500 w-1/6">
    Mobile Number<span> *</span>
  </label>
  <input
    type="text"
    id="mobile_number"
    name="mobile_number"
    value={data.mobile_number}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.mobile_number && <p className="text-red-500 text-sm">{errors.mobile_number}</p>}
</div>
</div>
<div className='w-1/2 justify-start items-start mt-5'>

                  {/* Logo Upload Section */}
                  <div className=" w-1/2 h-[50%] border-2 border-dashed border-gray-300 rounded-lg flex justify-center items-center relative">
                <input
                  type="file"
                  id="itemImage"
                  accept="image/*"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleImageUpload}
                />
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-24 h-24 object-cover rounded-lg"
                  />
                ) : (
                  <div className="text-gray-400 text-center">Click to upload image</div>
                )}
              </div>
              </div>
</div>
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="gst" className="block text-sm font-regular text-[#e54643] w-1/6">
    GST  <span className="text-[#e54643]">*</span>  </label>
  <input
    type="text"
    id="gst"
    name="gst"
    value={data.gst}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.gst && <p className="text-red-500 text-sm">{errors.gst}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="pan" className="block text-sm font-regular text-red-500 w-1/6">
    PAN <span> *</span>
  </label>
  <input
    type="text"
    id="pan"
    name="pan"
    value={data.pan}
    readOnly
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.pan && <p className="text-red-500 text-sm">{errors.pan}</p>}
</div>

  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="address1" className="block text-sm font-regular text-gray-700 w-1/6">
    Address
  </label>
  <input
    type="text"
    id="address1"
    name="address1"
    value={data.address1}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.address1 && <p className="text-red-500 text-sm">{errors.address1}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="city" className="block text-sm font-regular text-gray-700 w-1/6">
    City
  </label>
  <input
    type="text"
    id="city"
    name="city"
    value={data.city}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.city && <p className="text-red-500 text-sm">{errors.city}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label className="block text-sm font-regular text-gray-700 w-1/6">
    Serviceable Pincodes
  </label>
  <div className="w-1/3 relative">
    <div
      className="w-full flex items-center justify-between border border-gray-300 rounded-md px-3 py-2 bg-white cursor-pointer"
      onClick={() => setShowPincodeDropdown((prev) => !prev)}
    >
      <span className={`text-sm ${selectedPincodes.length ? 'text-gray-900' : 'text-gray-400'}`}>
        {selectedPincodes.length > 0
          ? `${selectedPincodes.length} selected`
          : 'Select city to load pincodes'}
      </span>
      <FiChevronDown
        className={`text-gray-500 transition-transform duration-200 ${showPincodeDropdown ? 'rotate-180' : ''}`}
        size={18}
      />
    </div>

    {showPincodeDropdown && (
      <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-[420px] overflow-hidden">
        <div className="border-b px-2 py-2">
          <div className="flex items-center gap-2">
            <FiSearch className="text-gray-400" size={16} />
            <input
              type="text"
              placeholder="Search pincode or area..."
              value={pincodeSearch}
              onChange={(e) => setPincodeSearch(e.target.value)}
              className="w-full py-2 outline-none text-sm"
            />
          </div>
        </div>

        <div className="max-h-56 overflow-y-auto">
          {isPincodeLoading ? (
            <div className="px-3 py-4 flex items-center gap-2 text-sm text-gray-500">
              <Spinner />
              Fetching pincodes...
            </div>
          ) : filteredPincodes.filter((item) =>
            `${item.pincode} ${item.area}`.toLowerCase().includes(pincodeSearch.toLowerCase())
          ).length > 0 ? (
            filteredPincodes
              .filter((item) =>
                `${item.pincode} ${item.area}`.toLowerCase().includes(pincodeSearch.toLowerCase())
              )
              .map((item) => {
                const isSelected = selectedPincodes.some(
                  (selected) => selected.pincode === item.pincode && selected.area === item.area
                );
                return (
                  <div
                    key={item.id}
                    className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    onClick={() => {
                      setSelectedPincodes((prev) =>
                        prev.some(
                          (selected) => selected.pincode === item.pincode && selected.area === item.area
                        )
                          ? prev.filter(
                              (selected) =>
                                !(selected.pincode === item.pincode && selected.area === item.area)
                            )
                          : [...prev, item]
                      );
                    }}
                  >
                    <div>
                      <p className="text-sm font-medium text-gray-900">{item.pincode}</p>
                      <p className="text-xs text-gray-500">{item.area}</p>
                    </div>
                    <input
                      type="checkbox"
                      readOnly
                      checked={isSelected}
                      className="h-4 w-4 text-blue-600 rounded border-gray-300"
                    />
                  </div>
                );
              })
          ) : (
            <div className="px-3 py-3 text-sm text-gray-500">
              {pincodeApiError || 'No pincodes found for this city.'}
            </div>
          )}
        </div>

        <div className="border-t px-3 py-3 bg-[#f9fafb]">
          <p className="text-sm text-gray-700">Add pincode manually anytime.</p>
          <div className="mt-2 grid gap-2 sm:grid-cols-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Pincode"
                value={manualPincode}
                onChange={(e) => {
                  setManualPincode(e.target.value);
                  if (pincodeApiError) setPincodeApiError('');
                }}
                className="w-full rounded-md border border-gray-300 px-2 py-2 text-sm"
              />
              {manualPincodeLoading && (
                <div className="absolute inset-y-0 right-2 flex items-center">
                  <Spinner />
                </div>
              )}
            </div>
            <input
              type="text"
              placeholder="Area name (optional)"
              value={manualArea}
              onChange={(e) => setManualArea(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-2 py-2 text-sm"
            />
            <button
              type="button"
              onClick={addManualPincode}
              className="rounded-md bg-[#408dfb] px-3 py-2 text-sm text-white hover:bg-[#3077d6]"
            >
              Add
            </button>
          </div>
          {pincodeApiError && (
            <p className="mt-2 text-sm text-red-500">{pincodeApiError}</p>
          )}
        </div>
      </div>
    )}
  </div>
</div>

  {selectedPincodes.length > 0 && (
    <div className="mt-2 flex flex-wrap gap-2 w-1/3">
      {selectedPincodes.map((item) => (
        <div
          key={item.id}
          className="flex items-center gap-2 rounded-full bg-[#eef2ff] px-3 py-1 text-sm text-gray-800"
        >
          <span>{`${item.pincode} - ${item.area}`}</span>
          <button
            type="button"
            onClick={() =>
              setSelectedPincodes((prev) =>
                prev.filter(
                  (selected) =>
                    !(selected.pincode === item.pincode && selected.area === item.area)
                )
              )
            }
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )}

  {errors.servicable_pincodes && (
    <p className="text-red-500 text-sm mt-1">{errors.servicable_pincodes}</p>
  )}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="pincode" className="block text-sm font-regular text-gray-700 w-1/6">
    Pincode
  </label>
  <input
    type="text"
    id="pincode"
    name="pincode"
    value={data.pincode}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.pincode && <p className="text-red-500 text-sm">{errors.pincode}</p>}
</div>

<div className="w-full flex flex-row items-start mb-4 space-x-2 mt-5 px-4 relative">
  <label className="block text-sm font-regular text-gray-700 w-1/6">
    State
  </label>

  <div className="w-1/3 relative">

    {/* Input field with dropdown icon */}
    <div
      onClick={() => setShowStateDropdown(!showStateDropdown)}
      className="w-full flex items-center justify-between border border-gray-300 rounded-md hover:border-blue-500 focus-within:border-blue-500 px-2 py-2 cursor-pointer bg-white"
    >
      <input
        type="text"
        value={data.state}
        placeholder="Select a state"
        readOnly
        className="outline-none text-sm text-gray-700 w-full cursor-pointer"
      />

      {/* Dropdown icon */}
      <FiChevronDown
        className={`text-gray-500 transition-transform duration-200 ${
          showStateDropdown ? "rotate-180" : ""
        }`}
        size={18}
      />
    </div>

    {/* Dropdown popup */}
    {showStateDropdown && (
      <div className="absolute z-50 w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1">

        {/* Search box with icon */}
        <div className="flex items-center border-b px-2">
          <FiSearch className="text-gray-400 mr-2" size={16} />

          <input
            type="text"
            placeholder="Search state..."
            value={stateSearch}
            onChange={(e) => setStateSearch(e.target.value)}
            className="w-full py-2 outline-none text-sm"
            autoFocus
          />
        </div>

        {/* States list */}
        <div className="max-h-48 overflow-y-auto">
          {filteredStates.length > 0 ? (
            filteredStates.map((state) => (
              <div
                key={state.value}
                onClick={() => {
                  setData({ ...data, state: state.label });
                  setShowStateDropdown(false);
                  setStateSearch("");
                }}
                className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
              >
                {state.label}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-gray-400 text-sm">
              No states found
            </div>
          )}
        </div>

      </div>
    )}
  </div>
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="website_url" className="block text-sm font-regular text-gray-700 w-1/6">
    Website URL
  </label>
  <input
    type="text"
    id="website_url"
    name="website_url"
    value={data.website_url}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
{errors.website_url && <p className='text-red-500 text-sm'>{errors.website_url}</p>}
</div>

{/* <div>
<Sidebar 
  onCancel={handleCancel} 
  isDirty={isDirty} 
  setShowCancelPopup={setShowCancelPopup}
/>
      
    </div>  */}

                </div>
              </div>

              <div className="mt-5 w-full">
                <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                  <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                    <button
                      className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md inline-flex items-center"
                      onClick={() => handleSubmit()}
                      disabled={isSaving}
                    >
                      <span>Save</span>
                      {isSaving && <Spinner />}
                    </button>
                    <button
                      className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                        isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                      }`}
                      disabled={isSaving}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                  </div>

            </div>
          </div>
        
      {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}
      {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {/* {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />} */}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
    </div>
    
  );
}

export default NewOrganization;
